import { useState } from "react"
import type { MarketplaceId } from "@nova-ai/shared"
import { useMagentoAttemptPreview, useSelectMagentoAttempt } from "./use-orders"

export function useMagentoAttemptSelection(marketplace: MarketplaceId, orderId: string) {
  const preview = useMagentoAttemptPreview(marketplace, orderId)
  const selection = useSelectMagentoAttempt(marketplace, orderId)
  const [entityId, setEntityId] = useState("")
  const [reason, setReason] = useState("")
  const [reviewedSet, setReviewedSet] = useState<string | null>(null)
  const canSubmit =
    !!preview.data &&
    reviewedSet === preview.data.candidateSet &&
    !!entityId &&
    !!reason.trim() &&
    !selection.isPending &&
    !preview.isFetching
  const refresh = async () => {
    setEntityId("")
    setReviewedSet(null)
    selection.reset()
    const refreshed = await preview.refetch()
    if (refreshed.data && !refreshed.isError) {
      setReviewedSet(refreshed.data.candidateSet)
    }
  }
  const submit = async () => {
    if (!preview.data || !canSubmit) {
      return
    }
    try {
      await selection.mutateAsync({
        entityId: entityId === "clear" ? null : entityId,
        reason: reason.trim(),
        expectedEntityId: preview.data.expectedEntityId,
        expectedVersion: preview.data.expectedVersion,
        candidateSet: preview.data.candidateSet,
      })
      setEntityId("")
      setReason("")
      setReviewedSet(null)
    } catch {
      setReviewedSet(null)
    }
  }
  const cancel = () => {
    setEntityId("")
    setReason("")
    setReviewedSet(null)
    selection.reset()
  }
  return {
    cancel,
    preview,
    selection,
    entityId,
    setEntityId,
    reason,
    setReason,
    reviewedSet,
    canSubmit,
    refresh,
    submit,
  }
}
